module.exports = __webpack_public_path__ + "img/sieckFinesseRelease3.0bb25602.png";